import Header from "./Header";
import Footer from "./Footer";
import BookMyTutorPromo from "@/components/BookMyTutorPromo";
import BackNav from "@/components/BackNav";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <BackNav />
      <main className="flex-1">{children}</main>
      {/* Auto-renders only when admin enables show_bookmytutor_promo in /admin/settings */}
      <BookMyTutorPromo variant="strip" />
      <Footer />
    </div>
  );
}
